import { render, staticRenderFns } from "./templates-card.vue?vue&type=template&id=5bdf35d0&scoped=true"
import script from "./templates-card.vue?vue&type=script&lang=ts"
export * from "./templates-card.vue?vue&type=script&lang=ts"
import style0 from "./templates-card.vue?vue&type=style&index=0&id=5bdf35d0&prod&lang=css&scoped=true"
import style1 from "./templates-card.vue?vue&type=style&index=1&id=5bdf35d0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdf35d0",
  null
  
)

export default component.exports